
export const uiuxbasic = {

  uidevice: {
    service: {
      name: 'uidevice',
      title: 'UI Device',
    }
  },

  uidoc: {
    service: {
      name: 'uidoc',
      title: 'UI Document',
    }
  },

  uilang: {
    service: {
      name: 'uilang',
      title: 'UI Language',
    }
  },

  uipage: {
    service: {
      name: 'uipage',
      title: 'UI Page',
    }
  },

  uisection: {
    service: {
      name: 'uisection',
      title: 'UI Section',
    }
  },

};
